import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlexibleHose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 23.04,
	viewBox: "0 0 50.0 23.04",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 50.0 1.52 L 50.0 21.52 M 0.0 1.52 L 0.0 21.52 M 0.0 11.52 A 19.0 35.0 0.0 0 1 25.0 11.52 A 19.0 35.0 0.0 0 0 50.0 11.52 M 4.2 4.02 L 6.5 6.72 M 12.5 1.52 L 12.5 4.52 M 20.5 4.02 L 17.9 6.82 M 26.7 10.32 L 23.2 12.92 M 32.5 16.52 L 29.2 19.52 M 37.5 18.52 L 37.5 21.52 M 43.7 15.92 L 46.4 19.02",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgFlexibleHose;
